import qs from 'qs'

export default {
    namespaced: true,
    state: {
        brands: [],
        mobileBrands: [],
        ordersBrands: [],
        selectedBrand: '',
        errors: {
            brands: {}
        },
        pagination: {
            page: 1,
            totalPages: 1,
            totalItems: 0,
            pageSize: 10
        },
        selectedFilter: {
            letter: ''
        }
    },
    getters: {
        brands(state) {
            return state.brands
        },
        brandName: state => id => {
            const brand = state.brands.find(
                brandItem => brandItem.BrandID === parseInt(id, 10)
            )

            return brand ? brand.BrandName : ''
        },
        pagination(state) {
            return state.pagination
        },
        selectedFilter(state) {
            return state.selectedFilter
        },
        selectedBrand(state) {
            return state.selectedBrand
        },
        ordersBrands(state) {
            return state.ordersBrands
        },
        ordersBrandsValuesArr(state) {
            return state.ordersBrands.map(brand => brand.BrandID)
        }
    },
    actions: {
        async getBrands({ commit, state }, data) {
            commit('SET_ERRORS', {
                key: 'brands',
                val: ''
            })

            const url = '/public/dict/brands'

            try {
                const resp = await this.$axios.get(url, {
                    params: {
                        ...data,
                        items: state.pagination.pageSize
                    },
                    paramsSerializer: function(params) {
                        return qs.stringify(params, { arrayFormat: 'brackets' })
                    }
                })
                commit('SET_BRANDS', resp.data)

                commit('SET_PAGINATION', {
                    key: 'page',
                    val: parseInt(resp.headers['page'], 10)
                })
                commit('SET_PAGINATION', {
                    key: 'totalPages',
                    val: parseInt(resp.headers['total-pages'], 10)
                })

                commit('SET_PAGINATION', {
                    key: 'pageSize',
                    val: parseInt(resp.headers['page-size'], 10)
                })

                commit('SET_PAGINATION', {
                    key: 'totalItems',
                    val: parseInt(resp.headers['total-records'], 10)
                })

                if (
                    (data && data.isMobilePagination) ||
                    state.pagination.page == 1
                ) {
                    commit('SET_MOBILE_BRANDS', resp.data)
                }
            } catch (e) {
                console.log('Ошибка ' + e.message)
                if (e.response) {
                    console.log(e.response.data)
                    commit('SET_ERRORS', {
                        key: 'brands',
                        val: e.response.data
                    })
                } else {
                    commit('SET_ERRORS', {
                        key: 'brands',
                        val: 'Ошибка'
                    })
                }
            }
        },
        getOrdersBrands({ commit }) {
            return this.$axios
                .get('/public/dict/brands', {
                    params: {
                        in_orders: true
                    }
                })
                .then(({ data }) => {
                    commit('SET_ORDERS_BRANDS', data)
                })
        },
        setPagination({ commit }, payload) {
            commit('SET_PAGINATION', payload)
        },
        setSelectedFilter({ commit }, payload) {
            commit('SET_SELECTED_FILTER', payload)
        },
        async subscribeOnBrand({ commit }, brandID) {
            try {
                await this.$axios.post(
                    `/public/dict/brands/subscribe/${brandID}`
                )
            } catch (e) {
                console.log('Ошибка ' + e.message)
            }
        },
        async unsubscribeOnBrand({ commit }, brandID) {
            try {
                await this.$axios.delete(
                    `/public/dict/brands/subscribe/${brandID}`
                )
            } catch (e) {
                console.log('Ошибка ' + e.message)
            }
        },
        async addBrandInFavourite({ commit }, brandID) {
            try {
                await this.$axios.post(
                    `/public/dict/brands/favorite/${brandID}`
                )
            } catch (e) {
                console.log('Ошибка ' + e.message)
            }
        },
        async removeBrandFromFavourite({ commit }, brandID) {
            try {
                await this.$axios.delete(
                    `/public/dict/brands/favorite/${brandID}`
                )
            } catch (e) {
                console.log('Ошибка ' + e.message)
            }
        },
        async requestAccessToBrand({ commit }, brandID) {
            try {
                await this.$axios.post(`/public/dict/brands/access/${brandID}`)
            } catch (e) {
                console.log('Ошибка ' + e.message)
            }
        }
    },
    mutations: {
        SET_ERRORS(state, error) {
            state.errors[error.key] = error.val
        },
        SET_BRANDS(state, brands) {
            state.brands = brands
        },
        SET_MOBILE_BRANDS(state, payload) {
            if (state.pagination.page == 1) {
                state.mobileBrands = payload
            } else {
                state.mobileBrands = [...state.mobileBrands, ...payload]
            }
        },
        SET_ORDERS_BRANDS(state, brands) {
            state.ordersBrands = brands
        },
        SET_PAGINATION(state, payload) {
            state.pagination[payload.key] = payload.val
        },
        SET_SELECTED_FILTER(state, payload) {
            state.selectedFilter[payload.key] = payload.val
        }
    }
}
